export interface Testimonial {
  id: string;
  name: string;
  location: string;
  avatar: string;
  content: string;
  rating: number;
  tripDestination: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 'test-1',
    name: '李美琪',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20friendly%20and%20approachable&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '跟着亚洲天堂的巴厘岛攻略走了一趟，简直完美！乌布的稻田酒店推荐得太棒了，悬崖日落晚餐也是此生最浪漫的体验。整个行程安排得刚刚好，不赶也不闲。亚洲天堂，名副其实！',
    rating: 5,
    tripDestination: '巴厘岛',
  },
  {
    id: 'test-2',
    name: '王建国',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle%20aged%20Chinese%20man%20with%20confident%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20friendly&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '第一次去尼泊尔徒步，靠的就是亚洲天堂的EBC指南。从装备清单到高原适应建议，每一页都是干货。尤其是推荐的那家加德满都旅馆，老板人超好！已经推荐给好几个朋友了。',
    rating: 5,
    tripDestination: '尼泊尔',
  },
  {
    id: 'test-3',
    name: '陈雅文',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20friendly%20and%20warm&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '东京隐藏景点的文章太实用了！等々力渓谷真的是东京秘境，人少景美，旁边的咖啡店也超赞。亚洲天堂推荐的谷中银座也去了，拍到了超满意的昭和风照片。感谢这么用心做内容的平台。',
    rating: 5,
    tripDestination: '东京',
  },
  {
    id: 'test-4',
    name: '赵志豪',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20man%20with%20bright%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20friendly%20and%20energetic&width=200&height=200&seq=avatar-04&orientation=squarish',
    content: '蜜月选了马尔代夫，多亏看了亚洲天堂的选岛攻略才没有被坑。一价全包的岛屿推荐非常中肯，浮潜条件分析也很专业。水下餐厅的体验终身难忘！',
    rating: 5,
    tripDestination: '马尔代夫',
  },
];